import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  PostTriggersResponseTO,
  TriggersCreatePayload,
} from 'models/automation/Triggers';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    PostTriggersResponseTO,
    BaseErrorResponse,
    TriggersCreatePayload
  >,
  'mutationFn' | 'mutationKey'
>;

const createTrigger = (payload: TriggersCreatePayload) => {
  return API.post<PostTriggersResponseTO, BaseErrorResponse>(
    '/api/internal/triggers',
    payload,
  );
};

const useCreateTriggerMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: createTrigger,
    ...options,
  });
};

export default useCreateTriggerMutation;
